<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Banner">
      <div class="row">
        <div class="col-md-6 form-group">
          Image
          <b-form-file
            id="file-small"
            v-model="selectedImage"
            @focus="imageEmpty = ''"
            @change="imageUpload"
          ></b-form-file>
          <div class="form-group" style="color: red" v-if="imageEmpty">
            {{ imageEmpty }}
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="saveChanges()"
          >Save Changes</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      selectedImage: [],
      imageEmpty: "",
      id: "",
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/banner/edit/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          if (response.data.status == "success") {
            this.selectedImage = response.data.banner.image;
            this.id = response.data.banner.id;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    imageUpload(event) {
      this.selectedImage = event.target.files[0];
    },
    async saveChanges() {
      if (this.selectedImage == "") {
        this.imageEmpty = "Banner image is required";
        return;
      }
      const formdata = new FormData();
      formdata.append("image", this.selectedImage);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/banner/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Banner updated successfully", "success");
             this.$router.push({name: 'Tables Banners'});
            this.name = "";
            //document.getElementById('fileinput__BV_file_outer_').lastChild.firstChild.textContent = ""
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          if (error.response.data.status == "error") {
            this.$swal("Error", error.response.data.message, "error");
          }
        });
    },
  },
};
</script>

